<template>
  <div class="w-100 bg-primary py-5 px-3 d-flex justify-content-center welcome-page-wrapper">

    <div class="d-flex flex-column align-items-center form-wrapper">

      <div class="p-4 logo-container w-100 d-flex flex-column align-items-center">
        <img src="@/../public/img/brand/logo_white.svg" alt="Wallkit" height="60" class="mb-1">
      </div>

      <div class="d-flex flex-column align-items-center py-5">
        <h1 class="font-weight-light mb-4 text-center">{{$t('onboarding.welcome')}}</h1>

        <b-spinner v-if="loader"
                   style="width: 3rem; height: 3rem;" />

        <div v-else class="text-center">
          <h3>Something went wrong.</h3>

          <router-link :to="{name: 'Login'}"
                       class="text-white text-center text-underline my-4 d-inline-block"
                       style="text-decoration: underline">Go To Login</router-link>
        </div>

<!--        <template v-else>-->
<!--          <p v-html="$t('onboarding.welcome_desc')" class="text-center mb-1"></p>-->
<!--          <p class="text-white mb-5">{{$t('onboarding.password_length')}}</p>-->

<!--          <b-form-->
<!--              class="w-100 form-container"-->
<!--              @submit.prevent="debounceSubmit"-->
<!--              novalidate-->
<!--              ref="form"-->
<!--              :validated="formValidated">-->

<!--            <b-input-group class="position-relative mb-4" v-if="!invite">-->
<!--              <b-form-input-->
<!--                  name="email"-->
<!--                  v-model.trim="form.email"-->
<!--                  class="w-100 rounded"-->
<!--                  type="text"-->
<!--                  :placeholder="$t('users.email')"-->
<!--                  autocomplete="email"-->
<!--                  :required="true">-->
<!--              </b-form-input>-->
<!--              <div class="invalid-tooltip">-->
<!--                {{$t('form.required_field')}}-->
<!--              </div>-->
<!--            </b-input-group>-->

<!--            <b-input-group class="position-relative mb-4">-->
<!--              <b-input-->
<!--                  autocomplete="off"-->
<!--                  v-model.trim="form.password"-->
<!--                  class="w-100 rounded"-->
<!--                  :type="inputTypeToggled"-->
<!--                  :required="true"-->
<!--                  :placeholder="$t('users.password')"-->
<!--                  :class="{'input-filled' : !!form.password}">-->
<!--              </b-input>-->
<!--              <div class="invalid-tooltip">-->
<!--                {{$t('form.required_field')}}-->
<!--              </div>-->
<!--              <i class="fas position-absolute text-white input-icon"-->
<!--                 :class="inputTypeToggled === 'password' ?  'fa-eye' : ' fa-eye-slash'"-->
<!--                 @click="togglePasswordVisibility"></i>-->
<!--            </b-input-group>-->

<!--            <b-input-group class="position-relative mb-4" v-if="invite">-->
<!--              <b-input-->
<!--                  autocomplete="off"-->
<!--                  v-model.trim="form.password_confirm"-->
<!--                  class="w-100 rounded"-->
<!--                  :type="inputTypeToggled"-->
<!--                  required-->
<!--                  :placeholder="$t('users.password_confirm')">-->
<!--              </b-input>-->
<!--              <div class="invalid-tooltip">-->
<!--                {{$t('form.required_field')}}-->
<!--              </div>-->
<!--              <i class="fas position-absolute text-white input-icon"-->
<!--                 :class="inputTypeToggled === 'password' ?  'fa-eye' : ' fa-eye-slash'"-->
<!--                 @click="togglePasswordVisibility"></i>-->
<!--            </b-input-group>-->

<!--            <b-btn-->
<!--                class="w-100 font-weight-bold p-2"-->
<!--                :disabled="disableForm"-->
<!--                type="submit">-->
<!--              {{$t('button.next')}}-->
<!--            </b-btn>-->

<!--          </b-form>-->
<!--        </template>-->

      </div>
    </div>

  </div>
</template>

<script>
  import axios from '@/utils/axios';
  export default {
    name: "Activate",
    props: {
      query: {
        type: Object
      },
      invite: {
        type: String
      },
      disableForm: {
        type: Boolean,
        default: false
      },
      loader: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        formValidated: false,
        inputTypeToggled: "password",
        type: null,
        form: {},
        debounceSubmit: () => {}
      }
    },
    created() {
      this.$store.dispatch('resource/deleteDefaultResource');
      if (this.query) {
        this.form.session = this.query.session;
        this.form.signature = this.query.signature
      }
      this.debounceSubmit = _.debounce(this.submit, 500);
      if (this.invite) {
        this.type = 'invitation';
        this.form.invite = this.invite
      } else {
        this.type = 'registration'
      }
    },
    methods: {
      async createdMess() {
        const data = {
          "id":49678,
          "email":"vs+933@wallkit.net",
          "first_name":"First",
          "last_name":"Last",
          "active":true,
          "confirm":true,
          "country":"",
          "city":"",
          "state":"",
          "company":"Company",
          "job":"Job",
          "zip":null,
          "created_at":"2022-03-22 13:06:27",
          "updated_at":"2022-03-22 13:06:27",
          "phone":null,
          "locked":false,
          "facebook_id":null,
          "google_id":null,
          "nick_name":null,
          "extra":{},
          "uid":null,
          "can_own_teams":false,
          "last_activity_date":"2022-03-22 13:06:28",
          "online":true,
          "photos":{
            "image_100":"https:\/\/www.gravatar.com\/avatar\/86a5b23adbbd3cebd615cf7b87a69700.jpg?s=100&d=mm",
            "image_300":"https:\/\/www.gravatar.com\/avatar\/86a5b23adbbd3cebd615cf7b87a69700.jpg?s=300&d=mm",
            "image_600":"https:\/\/www.gravatar.com\/avatar\/86a5b23adbbd3cebd615cf7b87a69700.jpg?s=600&d=mm"
          },
          "token_type":"bearer",
          "token":"476c15617a929d2e9b509e940a54823b8545d3d4",
          "expires":1679490388,
          "refresh_token":"ju23Kd2J9Bq5Hsk8aw479VA44VIvTc4Yvv0ffVU0",
          "session_id":"346795",
          "device":"desktop",
          "executed_time":0.9531,
          "memory_peak":"4.08.mb",
          "server":"Linux php7.3.6-1+ubuntu18.04.1+deb.sury.org+1",
          "req_guid":"1196021b7238b77a63ed757fc"
        };

        try {
          await this.$store.dispatch('auth/saveToken', { token: data.token });
          await this.$store.dispatch('auth/updateUser', { user: data });
          await this.$store.dispatch('auth/fetchUser')
          await this.$store.dispatch('resource/fetchResources');
          await this.$router.push({name: 'Home'});
          await this.$store.dispatch('resource/setDefaultResource');
          console.log('test');
        } catch (e) {
          console.log('E', e);
        }
      },
      togglePasswordVisibility() {
        if (this.inputTypeToggled === 'password') {
          this.inputTypeToggled = 'text'
        } else {
          this.inputTypeToggled = 'password'
        }
      },
      submit() {
        this.formValidated = true;
        if (this.$refs.form.checkValidity()) {
          if (this.invite) {
            this.postData('partners/confirmation', this.form, `/setup-step1/${this.type}`, true).then(resp => {
              if (resp) {
                try {
                  this.$store.dispatch('auth/saveToken', {token: resp.data.token});
                  this.$store.dispatch('auth/updateUser', {user: resp.data});
                  this.$store.dispatch('resource/fetchResources')
                }
                catch (err) {
                  console.error(err.response.data);
                }
              }
            })
          } else {
            axios.post('partners/registration', this.form).then(resp => {
              if (resp) {
                this.$store.dispatch('auth/updateUser', {user: {email: this.form.email}});
                this.$router.push({path: `/setup-step1/${this.type}`})
              }
            }).catch(e => {
              this.$noty.error(e.response.data.error_description)
            })
          }
        }
      }
    }
  }
</script>